export default __webpack_public_path__ + "static/media/firefighter_manifestations.669d7d15.jpg";